import Component from '../core/Component'
import Scroll from '../services/Scroll'

const STATES = {
    EXPANDED: 'is-expanded',
}

export default class ReferenceSection extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            list: null,
            more: null,
        }
    }

    prepare() {
        this.ref.more.addEventListener('click', this.handleMoreClick)
    }

    handleMoreClick = (event) => {
        event.preventDefault()

        const more = Component.getFromElement(this.ref.more)

        more.animateOut().then(() => {
            this.ref.list.classList.add(STATES.EXPANDED)
            this.ref.list.offsetWidth
            Scroll.resize()
        })
    }
}
